import { Anchor, Loader, Paper, Stack, Text, Title } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Link, useNavigate } from 'react-router';
import { api, podatki } from '../api/odjemalec';
import { sporocilo } from '../api/napaka';
import { TemnoOzadje } from '../postavitev/TemnoOzadje';
import { seja } from '../seja/seja';
import { NapakaVstopa, NazajNaPrijavo, ObrazecGesla } from './vstop';
import { zetonIzPovezave } from './zeton';

/**
 * Novo geslo iz povezave v e-pošti ({@code /pozabljeno-geslo/nastavi#žeton}); po nastavitvi se aplikacija prijavi.
 * Strežnik odklene račun in prekliče vse prejšnje prijave.
 */
export function NovoGeslo() {
  const navigate = useNavigate();
  const [zeton] = useState(zetonIzPovezave);
  const povezava = useQuery({
    queryKey: ['geslo', 'ponastavitev', zeton],
    retry: false,
    queryFn: ({ signal }) => podatki(api.GET('/api/geslo/ponastavitev', { signal, params: { query: { zeton } } })),
  });

  const nastavi = async (geslo: string) => {
    const o = await podatki(api.POST('/api/geslo/ponastavitev', { body: { zeton, geslo } }));
    // pri več podjetjih seja še ni vzpostavljena: prijava z izbiro podjetja
    await seja.prijava(o.uporabniskoIme!, geslo);
    window.history.replaceState(null, '', '/');
    void navigate('/', { replace: true });
  };

  return (
    <TemnoOzadje>
      <Paper radius="lg" p={36} shadow="xl">
        {povezava.isPending ? (
          <Stack align="center" py="lg">
            <Loader aria-label="Nalagam" />
          </Stack>
        ) : povezava.data ? (
          <ObrazecGesla
            naslov="Novo geslo"
            opis={
              <>
                Nastavite novo geslo za uporabnika <b>{povezava.data.uporabniskoIme}</b>.
              </>
            }
            gumb="Nastavi geslo in se prijavi"
            nastavi={nastavi}
          />
        ) : (
          <Stack gap="md">
            <Title order={2} size="h3">
              Povezava ne velja
            </Title>
            <NapakaVstopa>{sporocilo(povezava.error)}</NapakaVstopa>
            <Text size="sm" ta="center">
              <Anchor component={Link} to="/pozabljeno-geslo">
                Zahtevajte novo povezavo
              </Anchor>
            </Text>
            <NazajNaPrijavo />
          </Stack>
        )}
      </Paper>
    </TemnoOzadje>
  );
}
